import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import Autocomplete from 'react-autocomplete';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import StateOptions from '../../Common/StateOptions/StateOptions';
import ProvinceOptions from '../../Common/ProvinceOptions/ProvinceOptions';
import CountryOptions from '../../Common/CountryOptions/CountryOptions';
import TimezoneOptions from '../../Common/TimezoneOptions/TimezoneOptions';
import TimezoneCAOptions from '../../Common/TimezoneCAOptions/TimezoneCAOptions';
import Dropzone from 'react-dropzone';
import fileIcon from '../../../images/icons/file.svg';
import Help from '../../Common/Help/Help';
import './Venue.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Venue extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			files: [],
			isUseExisting: false,
			fullAutocompleteData: [],
			autocompleteData: [],
		}
	}

	componentWillReceiveProps(props) {
		if(props.event.venue.id){
			this.setState({
				isUseExisting: true,
			});
		}

		// https://github.com/DigitalTheatre/showtix4u-ui/issues/1641
		// /new/edit_event - default existing venue #1641
		if (props.venues.length > 0) {
			let isStreamingEvent = false;
			if (props.event.details.event_type === 'Video On Demand' || props.event.details.event_type === 'Live Stream' || props.event.details.event_type === 'Scheduled Content') {
				isStreamingEvent = true;
			}
			console.log('isStreamingEvent', isStreamingEvent);
			if (!isStreamingEvent) {
				console.log('isUseExisting', true);
				if (props.event.venue.venue_type === 'existing') {
					this.setState({
						isUseExisting: true,
					});
				}
			} else {
				console.log('isUseExisting', false);
				this.setState({
					isUseExisting: false,
				});
			}
		}
	}

	onDrop = (filesUpdate) => {
		this.setState({
			files: filesUpdate
		});
		this.props.uploadFile(filesUpdate[0], 'venue', 'chart');
	}

	loadVenues = (e) => {
		this.setState({
			isUseExisting: (e.target.value === "existing")
		});
		
		if(e.target.value !== "existing"){
			this.props.clearVenue();
		}

		this.props.handleChange(e);
	}

	onChange = (e) => {
		let value = e.target.value;
		this.props.handleVenueAddressChange(e.target.value);

        const doGetAutocomplete = async (value) => {
            try {
                const autocompleteResponse = await getAutocomplete(value);
				console.log('autocompleteResponse: ', autocompleteResponse);
				const autocompleteData = autocompleteResponse.data.predictions.map((prediction) => {
					const myObject = {
						'label': prediction.description,
						'value': prediction.place_id,
					}
					return myObject;
				});
				this.setState({
					fullAutocompleteData: autocompleteResponse.data.predictions,
                    autocompleteData,
                });
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getAutocomplete(value) {
            return await ApiRequest('/google/place-search', {
                method: 'POST',
                data: {
                    input: `${value}`,
                }
            });
		}
		if (value.length >= 5) {
			doGetAutocomplete(value);
		}
	}
	
	onSelect = (value) => {
		const fullAutocompleteData = this.state.fullAutocompleteData;
		let place_id = value;
		fullAutocompleteData.forEach((data) => {
			if (data.place_id === value) {
				place_id = data.place_id;
			}
		});
		const doGetAddress = async (value) => {
            try {
                const addressResponse = await getAddress(value);
				console.log('addressResponse: ', addressResponse);
				this.getLatLng(addressResponse.data);
				this.props.handleFullVenueAddressChange(addressResponse.data);
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getAddress(value) {
            return await ApiRequest('/google/place-detail', {
                method: 'POST',
                data: {
                    placeid: `${value}`,
                }
            });
        }
		doGetAddress(place_id);
	}

	getLatLng = (address) => {
		const doGetLatLng = async (value) => {
            try {
				const latitude = value.latitude;
				const longitude = value.longitude;
                const latLngResponse = await getLatLng(latitude, longitude);
				console.log('latLngResponse: ', latLngResponse);
				this.props.setLatLng(latLngResponse.data.timeZoneId);
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getLatLng(latitude, longitude) {
            return await ApiRequest('/google/timezone', {
                method: 'POST',
                data: {
					latitude: `${latitude}`,
					longitude: `${longitude}`,
                }
            });
        }
		doGetLatLng(address);
	}

	renderItem = (item, isHighlighted) =>{
        return (
            <div className="item" style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                {item.label}
            </div>   
        ); 
	}
	
	getItemValue= (item) =>{
        return `${item.value}`;
	}

	renderExistingVenues = () => {
		return (
			this.props.venues.map((venue, j) => (
				venue.name !== 'Stream Event' && (
					[
						(venue.venue_type === 'general-admission' ?
							<option key={j} value={venue.id}>{venue.name} - {venue.venue_type} - {venue.max_seats} {strings.seats}</option>
						:
							<option key={j} value={venue.id}>{venue.name} - {venue.venue_type}</option>
						)
					]
				)
			))
		);
	}

	renderHelp = () => {
		let event_type = this.props.event.details.event_type;
        if (event_type !== 'Video On Demand' && event_type !== 'Live Stream' && event_type !== 'Scheduled Content') {
			return (
				strings.helps.map((help, i) =>
					<Help help={help} key={i} />
				)
			);
		}
	}
	
	render() { 
		return ( 
			<div className="showtix-section showtix-background__primary-1">
				<div className="container">
					<h1>{strings.title}</h1>

					<div className="row">
						<div className="col-12 col-lg-9">
							{this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content' && (
								<div className="row">
									{!this.props.event.isPublished &&
										<div className="col-12 col-md-8">
											<div className="showtix-form__group">
												<div className="showtix-form__select">
													<select className="showtix-input"
														object="venue"
														name="venue_type"
														onChange={this.loadVenues}
														value={this.props.event.venue.id ? 'existing' : undefined || this.state.isUseExisting ? 'existing' : undefined}
													>
														<option value="reserved">{strings.createReserved}</option>
														<option value="general-admission">{strings.createGeneral}</option>
														{this.props.venues.length > 0 &&
															<option value="existing">{strings.useExisting}</option>
														}
													</select>
												</div>
											</div>
										</div>
									}
								</div>
							)}

							{/* Fix select that disappear when venue is populated */}
							{ (this.state.isUseExisting && this.props.venues.length > 0) && (
								/* Only show this dropdown is event is NOT published */
								!this.props.event.isPublished && (
									this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content' && (
										<div className="row">
											<div className="col-12 col-md-8">
												<div className="showtix-form__group">
													<div className="showtix-form__select">
														<select className="showtix-input"
															object="venue"
															name="existing"
															value={this.props.event.venue.id}
															onChange={this.props.loadVenue}
														>
															<option value="">{strings.selectExisting}</option>
															{this.renderExistingVenues()}
														</select>
													</div>
												</div>
											</div>
										</div>
									)
								)
							)}

							<div className="row">
								{this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content' && (
									<div className="col-12 col-md-4">
										<div className={"showtix-form__group " + (!this.props.validation.venue.name.valid ? 'showtix-form__error' : '')}>
											<label className="showtix-label" htmlFor="venue-name">{strings.venueName}*</label>
											<div className="showtix-form__input">
												<input
													className="showtix-input"
													type="text"
													object="venue"
													name="name"
													id="venue-name"
													value={this.props.event.venue.name}
													validation="(^(?!\s*$).+)"
													onChange={this.props.handleChange}
													onBlur={this.props.validateRequiredField}
													required
												/>
											</div>
											{!this.props.validation.venue.name.valid &&
												<div className=" showtix-note error">
													{this.props.validation.venue.name.msg}
												</div>
											}
										</div>
									</div>
								)}

								{this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content' && (
									<div className="col-12 col-md-4">
										<div className={"showtix-form__group " + (!this.props.validation.venue.address.valid ? 'showtix-form__error' : '')}>
											<label className="showtix-label" htmlFor="venue-address">{strings.venueAddress}*</label>
											<div className="showtix-form__input">
												<Autocomplete
													getItemValue={this.getItemValue}
													items={this.state.autocompleteData}
													renderItem={this.renderItem}
													value={this.props.event.venue.address}
													onChange={this.onChange}
													onSelect={this.onSelect}
													menuStyle={{
														background: '#fff',
														padding: '0',
														position: 'absolute',
														top: '44px',
														left: '0',
														right: '0',
														overflow: 'auto',
														zIndex: '2',
														maxHeight: '200px',
													}}
												/>

												{/* <input
													className="showtix-input"
													type="text"
													object="venue"
													name="address"
													id="venue-address"
													validation="(^(?!\s*$).+)"
													value={this.props.event.venue.address}
													onChange={this.props.handleVenueAddressChange}
													onBlur={this.props.validateRequiredField}
													required
												/> */}
											</div>
											{!this.props.validation.venue.address.valid &&
												<div className=" showtix-note error">
													{this.props.validation.venue.address.msg}
												</div>
											}
										</div>
									</div>
								)}

								<div className="col-12 col-md-4">
									<div className={"showtix-form__group " + (!this.props.validation.venue.city.valid ? 'showtix-form__error' : '')}>
										<label className="showtix-label" htmlFor="venue-city">{strings.venueCity}*</label>
										<div className="showtix-form__input">
											<input
												id="venue-city"
												className="showtix-input"
												type="text"
												object="venue"
												name="city"
												validation="(^(?!\s*$).+)"
												value={this.props.event.venue.city}
												onChange={this.props.handleChange}
												onBlur={this.props.validateRequiredField}
												required
											/>
										</div>
										{!this.props.validation.venue.city.valid &&
											<div className=" showtix-note error">
												{this.props.validation.venue.city.msg}
											</div>
										}
									</div>
								</div>
							
								<div className="col-12 col-md-4">
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="venue-state">{strings.venueCountry}*</label>
										<div className="showtix-form__select">
											<select className="showtix-input"
												object="venue"
												name="country"
												id="venue-country"
												value={this.props.event.venue.country}
												onChange={this.props.handleChange}>
												<CountryOptions />
											</select>
										</div>
									</div>
								</div>

								<div className="col-12 col-md-4">
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="venue-state">{strings.venueProvince}*</label>
										<div className="showtix-form__select">
											{ (this.props.event.venue.country === "US" || this.props.event.venue.country === undefined) ?
												<select className="showtix-input"
													object="venue"
													name="state"
													id="venue-state"
													value={this.props.event.venue.state}
													onChange={this.props.handleChange}
												>
													<StateOptions />
												</select>
												:
												<select
													className="showtix-input"
													object="venue"
													name="state"
													id="venue-state"
													value={this.props.event.venue.state}
													onChange={this.props.handleChange}
												>
													<ProvinceOptions />
												</select>
											}
										</div>
									</div>
								</div>

								<div className="col-12 col-md-4">
									<div className={"showtix-form__group " + (!this.props.validation.venue.zip.valid && this.props.event.venue.zip === '' ? 'showtix-form__error' : '')}>
										<label className="showtix-label" htmlFor="venue-zip">{strings.venueZip}*</label>

										<div className="showtix-form__input">
											<input
												type="text"
												className="showtix-input"
												placeholder={strings.venueZip}
												id="venue-zip"
												object="venue"
												name="zip"
												value={this.props.event.venue.zip}
												validation="(^\d{5}(-\d{4})?$)|(^[ABCEGHJKLMNPRSTVXYabceghjklmnprstvxy]{1}\d{1}[A-Za-z]{1} *\d{1}[A-Za-z]{1}\d{1}$)"
												onChange={this.props.handleChange}
												onBlur={this.props.validateRequiredField}
												required
											/>
										</div>
										{!this.props.validation.venue.zip.valid &&
											<div className=" showtix-note error">
												{this.props.validation.venue.zip.msg}
											</div>
										}
									</div>
								</div>

								{this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content' && (
									<div className="col-12 col-md-4">
										<div className={"showtix-form__group " + (!this.props.validation.venue.phone.valid ? 'showtix-form__error' : '')}>
											<label className="showtix-label" htmlFor="venue-phone">{strings.venuePhone}*</label>

											<div className="showtix-form__input">
												<input
													type="text"
													className="showtix-input"
													placeholder="Enter a phone number"
													id="venue-phone"
													object="venue"
													name="phone"
													value={this.props.event.venue.phone}
													validation="(^(\d{3}-?\s?\d{3}-?\s?\d{4}\s?)?(x\d{2,4})?$)"
													onChange={this.props.handleChange}
													onBlur={this.props.validateRequiredField}
													required
												/>
											</div>
											{!this.props.validation.venue.phone.valid &&
												<div className=" showtix-note error">
													{this.props.validation.venue.phone.msg}
												</div>
											}
										</div>
									</div>
								)}
								{this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content' && (
									<div className="col-12 col-md-4">
										<div className="showtix-form__group">
											<label className="showtix-label" htmlFor="venue-fax">{strings.venueFax}</label>

											<div className="showtix-form__input">
												<input
													type="text"
													className="showtix-input"
													placeholder="Enter a fax number"
													id="venue-fax"
													object="venue"
													name="fax"
													value={this.props.event.venue.fax}
													validation="(^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$)"
													onChange={this.props.handleChange}
													onBlur={this.props.validateRequiredField}
												/>
											</div>
											{!this.props.validation.venue.fax.valid &&
												<div className=" showtix-note error">
													{this.props.validation.venue.fax.msg}
												</div>
											}
										</div>
									</div>
								)}

								<div className="col-12 col-md-4">
								<div className={"showtix-form__group " + (!this.props.validation.venue.timezone.valid ? 'showtix-form__error' : '')}>
										<label className="showtix-label" htmlFor="venue-timezone">{strings.venueTimezone}*</label>

										<div className="showtix-form__select">
											<select className="showtix-input"
												object="venue"
												name="timezone"
												id="venue-timezone"
												value={this.props.event.venue.timezone}
												onChange={this.props.handleChange}
												disabled={this.props.event.isPublished && this.props.user.role !== 'admin' && this.props.real_user.role !== 'admin' || this.state.isUseExisting && this.props.user.role !== 'admin' && this.props.real_user.role !== 'admin'}
												required
											>
											{ (this.props.event.venue.country === "US" || this.props.event.venue.country === undefined) ?
												<TimezoneOptions />
												:
												<TimezoneCAOptions />
											}
											</select>
										</div>
										{!this.props.validation.venue.timezone.valid &&
											<div className=" showtix-note error">
												{this.props.validation.venue.timezone.msg}
											</div>
										}
									</div>
								</div>

								{ (this.props.event.venue.venue_type === 'reserved' && this.props.event.venue.status === 'pending') &&
									<div className="col-12 col-md-8">
										<div className="showtix-form__group">
											<label className="showtix-label">{strings.venueSeatingChart}
												<span id="tooltip-seatingChart" className="showtix-tooltip">!</span>
												<Tooltip placement="top" target="tooltip-seatingChart">
													{strings.venueSeatingChartTooltip}
												</Tooltip>
											</label>

											<div className="showtix-form__drop">
												<Dropzone
													className="showtix-dropzone"
													onDrop={this.onDrop}
													maxSize={10000000}
													multiple={false}>

													<div className="showtix-dropzone__title">{strings.dragAndDropDocuments}</div>
													<img src={fileIcon} alt="Upload document" />
													<div className="showtix-dropzone__file">
														{
															this.state.files.map(f => <span key={f.name}>{f.name} - {f.size} bytes</span>)
														}
													</div>

												</Dropzone>
											</div>
										</div>
									</div>
								}

								{ (this.props.event.venue.venue_type === 'general-admission') && (this.props.event.details.event_type !== 'Video On Demand' && this.props.event.details.event_type !== 'Live Stream' && this.props.event.details.event_type !== 'Scheduled Content') &&
									<div className="col-12 col-md-4">
										<div className={"showtix-form__group " + (!this.props.validation.venue.max_seats.valid && this.props.event.venue.max_seats !== '' ? 'showtix-form__error' : '')}>
											<label className="showtix-label" htmlFor="venue-quantity">{strings.venueQty}*</label>

											<div className="showtix-form__input">
												<input
													type="text"
													className="showtix-input"
													placeholder="Enter a quantity"
													id="venue-quantity"
													object="venue"
													name="max_seats"
													value={this.props.event.venue.max_seats || ''}
													validation="(^\d+$)"
													onChange={this.props.handleChange}
													onBlur={this.props.validateRequiredField}
													//disabled={this.props.selectedMTIshow.quantity_stream_tickets || this.props.event.details.quantity_stream_tickets}
												/>
											</div>
											{!this.props.validation.venue.max_seats.valid &&
												<div className=" showtix-note error">
													{this.props.validation.venue.max_seats.msg}
												</div>
											}
										</div>
									</div>
								}
							</div>
						</div>

                        { strings.helps &&
						<div className="col-12 col-lg-3">
							{this.renderHelp()}
						</div>
                        }
					</div>
					{this.props.event.venue.venue_type === 'reserved' && (
						<React.Fragment>
							<hr />
							<div className="row">
								<div className="col-12 col-lg-3">
									<h2>{strings.socialDistance}</h2>
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="seat-space">{strings.seatSpacing}</label>
										<div className="showtix-form__select">
											<select className="showtix-input"
												object="details"
												name="seat_spacing"
												id="seat-space"
												value={this.props.event.details.seat_spacing}
												onChange={this.props.handleChange}
											>
												<option value="0">0</option>
												<option value="1">1</option>
												<option value="2">2</option>
												<option value="3">3</option>
												<option value="4">4</option>
											</select>
										</div>
									</div>
								</div>
								<div className="col-12 col-lg-6"></div>
								{ strings.tips &&
									<div className="col-12 col-lg-3">
										{strings.tips.map((tip, i) =>
											<Help help={tip} key={i} />
										)}
									</div>
								}
							</div>
						</React.Fragment>
					)}
				</div>
			</div>
		)
	}
}

Venue.propTypes = {
    event: PropTypes.shape({
        isPublished: PropTypes.bool,
        venue: PropTypes.shape({
            venue_type: PropTypes.string,
            name: PropTypes.string,
            address: PropTypes.string,
            city: PropTypes.string,
            state: PropTypes.string,
            zip: PropTypes.string,
            phone: PropTypes.string,
            fax: PropTypes.string,
            timezone: PropTypes.string
        })
    }),
    validation: PropTypes.shape({
        venue: PropTypes.shape({
            name: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            address: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            city: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            zip: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            phone: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            fax: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
            max_seats: PropTypes.shape({
                valid: PropTypes.bool,
                msg: PropTypes.string
            }),
        })
    }),
    uploadFile: PropTypes.func,
    clearVenue: PropTypes.func,
    handleChange: PropTypes.func,
    validateRequiredField: PropTypes.func,
    loadVenue: PropTypes.func
}
 
export default Venue;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/Venue/Venue.js